import * as React from 'react'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { Theme } from '@evenfinancial/even-ts-static'

export const ThemeContext = React.createContext({} as Theme)

export const ThemeProvider = ({ children }) => (
  <ThemeConsumer>{(theme) => <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>}</ThemeConsumer>
)
